export default "__VITE_ASSET__UAiVbyXb__"